// provides a context for the drawer state

import { Drawer } from "@src/components/Drawer";
import React, { createContext, useCallback, useContext, useState } from "react";
import ReactDOM from "react-dom";

type DrawerContextType = {
  open: (content?: React.ReactNode) => void;
  close: () => void;
};

export const DrawerContext = createContext<DrawerContextType>({
  open: () => {},
  close: () => {},
});

export const DrawerProvider = ({ children }: { children: React.ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState<React.ReactNode>(null);

  const openDrawer = useCallback((drawerContent?: React.ReactNode) => {
    setContent(drawerContent);
    setIsOpen(true);
  }, []);

  const closeDrawer = useCallback(() => {
    setIsOpen(false);
    setContent(null);
  }, []);

  return (
    <>
      <DrawerContext.Provider value={{ open: openDrawer, close: closeDrawer }}>
        {children}
        {ReactDOM.createPortal(
          <Drawer isOpen={isOpen} onClose={closeDrawer}>
            {content}
          </Drawer>,
          document.body,
        )}
      </DrawerContext.Provider>
    </>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useDrawer = () => useContext(DrawerContext);
